import styled, { css } from 'styled-components';
import { ListGroup, Form } from 'react-bootstrap';

import { Card } from '_components/_core';

export const ResponsiveEditorWrapper = styled.div`
  height: ${props => (props.isMobile ? '400px' : '650px')};
  margin-bottom: ${props => (props.isMobile ? '0.5rem' : '1rem')};
  position: relative;
  
  @media (max-width: 768px) {
    margin-bottom: 17rem;
  }
`;

export const ContractListItem = styled(ListGroup.Item)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  cursor: pointer;

  &:hover {
    background-color: #EFF3F5;
  }
  &.active {
    background-color: #e9ecef;
  }
  &.selected {
    background-color: #ECEEF1;
  }
  
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    
    > div:last-child {
      margin-top: 0.5rem;
      align-self: flex-end;
    }
  }
`;

export const VariablesList = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const VariableFormGroup = styled(Form.Group)`
  width: 100%;
  padding-right: 0.5rem;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    width: 100%;
    padding-right: 0;
  }
`;

export const StyledInfo = styled.h2`
  font-size: 0.9rem;
  font-weight: 400;
`;

export const PrintButtonContainer = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: end;
  align-items: center;
  
  @media (max-width: 768px) {
    position: absolute;
    bottom: -40px;
    left: 0;
    right: 0;
    width: 100%;
  }
`;

export const StepContainer = styled.div`
  /* position: relative;
  margin-bottom: 2rem;
  padding: 0.5rem 0.5rem 0.5rem 3rem;
  border-left: 2px solid #e9ecef;
  
  &:last-child {
    margin-bottom: 1rem;
  }
  
  @media (max-width: 768px) {
    padding: 0.75rem 0.5rem 1rem 2.5rem;
    margin-bottom: 2.5rem;
  } */
`;

export const StepNumber = styled.div`
  /* position: absolute;
  left: -20px;
  top: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #4C8BF5;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px; */
  
  /* @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    left: -16px;
    font-size: 1rem;
  } */
`;

export const StepTitle = styled.h4`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  /* font-size: 14px;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  } */
`;

export const StepContent = styled.div`
  margin-bottom: 0.5rem;
  
  @media (max-width: 768px) {
    margin-bottom: 0.25rem;
  }
`;

export const MobileStepWrapper = styled.div`
  @media (max-width: 768px) {
    padding: 1rem;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin-bottom: 1.5rem;
  }
`;

export const CustomCard = styled(Card)`
  border: 1px solid #F1F1F4;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  padding-bottom: 0;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
`;

export const CustomCardHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #F1F1F4;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    font-size: 16px;
    margin-bottom: 0;
    color: #071437;
  }

  ${({ isClickable }) =>
    isClickable &&
    css`
    cursor: pointer;

    :hover {
      background-color: #F9F9FB;
    }
  `}
`;

export const CustomCardBody = styled.div`
  padding: 16px;

  ${({ noPadding }) =>
    noPadding &&
    css`
    padding: 0;
  `}

`;

export const CustomCardFooter = styled.div`
  padding: 8px 16px;
  border-top: 1px solid #F1F1F4;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;
